import React, { useState } from 'react';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  Typography,
} from '@mui/material';

const elementStyle = {
  base: {
    fontSize: '16px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    color: '#333',
    '::placeholder': { color: '#aaa' },
  },
  invalid: {
    color: '#f44336',
  },
};

const StripeCardForm = ({ onError }) => {
  const [error, setError] = useState(null);
  const [focused, setFocused] = useState(null);

  const handleFocus = (field) => setFocused(field);
  const handleBlur = () => setFocused(null);
  const handleError = (event) => {
    if (event?.error?.message) {
      setError(event.error.message);
      onError?.(event.error.message);
    } else {
      setError(null);
      onError?.('');
    }
  };

  const renderStripeField = (id, label, Element) => (
    <FormControl fullWidth variant="outlined" margin="normal">
      <InputLabel shrink htmlFor={id}>{label}</InputLabel>
      <Box
        id={id}
        sx={{
          border: '1px solid',
          borderColor: error && focused === id ? 'error.main' : focused === id ? 'primary.main' : 'rgba(0, 0, 0, 0.23)',
          borderRadius: 1,
          padding: '18.5px 14px',
          mt: 1,
          '&:hover': {
            borderColor: 'black',
          },
          boxShadow: focused === id ? '0 0 0 2px rgba(25, 118, 210, 0.25)' : 'none',
          backgroundColor: 'background.paper',
        }}
      >
        <Element
          options={{ style: elementStyle }}
          onFocus={() => handleFocus(id)}
          onBlur={handleBlur}
          onChange={handleError}
        />
      </Box>
      {error && focused === id && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );

  return (
    <Box>
      {renderStripeField('card-number', 'Card Number', CardNumberElement)}
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          {renderStripeField('card-expiry', 'Expiration Date', CardExpiryElement)}
        </Box>
        <Box sx={{ flex: 1 }}>
          {renderStripeField('card-cvc', 'CVC', CardCvcElement)}
        </Box>
      </Box>

      {error && (
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default StripeCardForm;
